var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-chatbot-wrapper" },
    [
      _vm.websiteBuilder
        ? _c("WebsiteChatbotBuilder", {
            on: {
              cancel: function () {
                return (_vm.websiteBuilder = false)
              },
            },
          })
        : _c("div", { staticClass: "create-chatbot" }, [
            _c(
              "div",
              { staticClass: "sticky-header" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v("Set up your chatbot"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                Train your chatbot with data, use our ready-to-use templates or start from scratch.\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "btnClose",
                    attrs: { small: "" },
                    on: { click: _vm.close },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "items" }, [
              _c(
                "div",
                {
                  staticClass: "block block-scratch",
                  on: { click: _vm.createBlankStory },
                },
                [
                  _c("div", { staticClass: "icon" }, [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [_vm._v("Blank Bot")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "Create a blank chatbot, which you can train and customize later."
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "block block-ai",
                  on: {
                    click: function ($event) {
                      _vm.websiteBuilder = true
                    },
                  },
                },
                [
                  _c("div", { staticClass: "ai-badge" }, [
                    _c("span", { staticClass: "lang" }, [
                      _vm._v("ENGLISH/TURKISH"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("AI")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("public"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [_vm._v("Website")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    Crawl your website’s content to get answers to popular user questions.\n                "
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }